<template lang="pug">
  DataTablePage(
      mainColumn=""
      longColumn=""
      title="数据历史查询"
      label="数据历史"
      labelName="num"
      :resource="resource"
      :requestData="requestData"
      :columns="columns"
      :tableInitList="tableInitList"
      :tableFullList="tableFullList"
      :filterInitList="filterInitList")
</template>
<script>
import DataTablePage from '@/containers/DataTablePage'
import columns from './waterColumns.js'
import { URL } from '@/utils/common'
import { expire } from '@/utils/auth'
export default {
  name: 'DataQueryHistory',
  components: {
    DataTablePage
  },
  mounted () {
    let result = expire()
    if (!result) {
      this.$router.push('/login')
    }
  },
  data () {
    return {
      resource: '/meterPayload/history/reading',
      requestData: this.$route.params,
      tableInitList: ['time', 'image', 'num', 'result', 'type'],
      tableFullList: ['time', 'image', 'num', 'result', 'type'],
      filterInitList: ['time', 'type', 'result'],
      columns: {
        ...columns,
        image: {
          label: '抄表行码',
          width: 220,
          type: 'custom',
          html: true,
          magnifying: {
            height: '180px',
            width: '200px'
          },
          style: {
            textAlign: 'center'
          },
          customRender (data, full, index) {
            return `<img src="${URL}/${data}" style="height:24px"></img>`
          }
        }
      }
    }
  }
}
</script>
<style lang="sass" scoped>

</style>



// WEBPACK FOOTER //
// DataQueryHistory.vue?2cf4be14